import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_COMBOBOX, KENDO_MULTISELECT } from "@progress/kendo-angular-dropdowns";
import { KENDO_SVGICON } from "@progress/kendo-angular-icons";
import { KENDO_CHECKBOX, KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { caretAltDownIcon } from "@progress/kendo-svg-icons";
import { ChangedFieldDirective } from "../../../changed-field.directive";
import { FieldMessageComponent } from "../../../field-message/field-message.component";
import { FlightEditLookups } from "../../../form/flight-edit-lookups";
import { FlightGroup } from "../../../form/flight-form-group";

/** The flight itself: its type, VEMD and positioning, the lists of the organization it picks from, landings, cycles and hooks. */
@Component({
    selector: "app-flight-group",
    imports: [
        ChangedFieldDirective,
        FieldMessageComponent,
        ReactiveFormsModule,
        TranslatePipe,
        KENDO_COMBOBOX,
        KENDO_MULTISELECT,
        KENDO_SVGICON,
        KENDO_TEXTBOX,
        KENDO_CHECKBOX,
        KENDO_NUMERICTEXTBOX,
    ],
    templateUrl: "./flight-group.component.html",
    styleUrl: "../../../edit-fields.scss",
})
export class FlightGroupComponent {
    readonly group = input.required<FlightGroup>();
    readonly lookups = input.required<FlightEditLookups>();
    /** A ground run keeps its type. */
    readonly groundRun = input(false);

    readonly icons = { arrow: caretAltDownIcon };
}
